// extracted by mini-css-extract-plugin
export var circle = "SocialShare-module--circle--8WmR8";
export var eMail = "SocialShare-module--eMail--zOfPS";
export var facebook = "SocialShare-module--facebook--7f0jW";
export var linkedin = "SocialShare-module--linkedin--2rOic";
export var socialSharingButton = "SocialShare-module--socialSharingButton--8Kxe4";
export var twitter = "SocialShare-module--twitter--+d4iT";
export var whatsapp = "SocialShare-module--whatsapp--fuovm";
export var xing = "SocialShare-module--xing--rS7jD";